import api from "services/axiosInstance";
import { ITrackSplit } from "types/musicData";

export const UpdateSplitSheet = async (
  sheetdata: ITrackSplit[],
  splitSheetId: string
) => {
  try {
    const adjustedSheetData = sheetdata.map((split) => ({
      ...split,
      percentage: split.percentage * 0.85
    }));

    const body = { entries: [...adjustedSheetData] };
    const { data } = await api.put(`/split-sheets/${splitSheetId}`, body);
    return data.data;
  } catch (e) {
    throw e;
  }
};
